/**
 * Hook to filter drivers based on the payload
 * @param drivers - List of drivers to be filtered
 * @param payload - Payload containing driver notification preferences for the current type
 * @returns List of filtered drivers
 */
import { useMemo } from 'react';
import { OrderSharePreviewParams } from '../../../redux/api/orders/orders.model';
import { INotifyDriverWithFullSegment } from '../TwNotifyDriver';

interface UseDriverFilteringProps {
  /** List of drivers to be filtered */
  drivers: INotifyDriverWithFullSegment[];
  /** Payload containing driver notification preferences for the current type */
  payload: OrderSharePreviewParams[];
}

const useDriverFiltering = ({
  drivers,
  payload
}: UseDriverFilteringProps): {
  filteredDrivers: INotifyDriverWithFullSegment[];
} => {
  const filteredDrivers = useMemo(
    () =>
      drivers.filter((driver) => {
        const payloadItem = payload.find(
          (payload) =>
            payload.driver_id === driver.driverId && payload.trip_id === driver.fullSegment.id
        );
        return !driver.removed && !!payloadItem;
      }),
    [drivers, payload]
  );

  return { filteredDrivers };
};

export default useDriverFiltering;
